import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";
import { pushIf } from "./utils/pushIf";

const reduceAdjustCapacityNotificationState = createStateReducer(initialState, {
  [events.adjustCapacitySucceeded]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "adjustCapacity",
        flags: ["success"],
        args: { success: "true" },
      },
      state.queue,
    ),
  }),
  [events.adjustCapacityFailed]: (state, { error }) => ({
    ...state,
    queue: updateNotification(
      {
        key: "adjustCapacity",
        flags: pushIf({
          ...error,
          failure: !Object.values(error).includes(true),
        }),
        args: { failure: "true" },
      },
      state.queue,
    ),
  }),
});

export { reduceAdjustCapacityNotificationState };
